import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Paper } from "@mui/material";
import hospitais from "../../utils/nomeHospital";

function safeB64Decode(input) {
    if (!input) return null;
    try {
        // Corrige base64url (- e _)
        let s = input.replace(/-/g, "+").replace(/_/g, "/");
        const pad = s.length % 4;
        if (pad) s += "=".repeat(4 - pad);

        // Decodifica no navegador
        if (typeof window !== "undefined" && typeof window.atob === "function") {
            return decodeURIComponent(
                Array.prototype.map
                    .call(window.atob(s), function (c) {
                        return "%" + c.charCodeAt(0).toString(16).padStart(2, "0");
                    })
                    .join("")
            );
        }

        // Fallback para Node (opcional)
        return Buffer.from(s, "base64").toString("utf-8");
    } catch (e) {
        console.error("Erro ao decodificar Base64:", e);
        return null;
    }
}

const Header = () => {
    const { cnes } = useParams();
    const [nomeHospital, setNomeHospital] = useState("");

    useEffect(() => {
        const decoded = safeB64Decode(cnes) || cnes || "";
        const nome = (decoded && hospitais[decoded]) || decoded || "Hospital não encontrado";
        setNomeHospital(nome);
    }, [cnes]);

    return (
        <header className="ps-header">
            <h1 className="ps-header__hospital">{nomeHospital}</h1>
        </header>
    );
};

export default Header;